import Avatar from "@material-ui/core/Avatar"

const UserAvatar = props => {
  const { user, ...rest } = props
  const { fullName, firstName, lastName, profileImage } = user

  if (!profileImage) {
    return (
      <Avatar {...rest}>{`${firstName.charAt(0)}${lastName.charAt(0)}`}</Avatar>
    )
  }

  return <Avatar {...rest} alt={fullName} src={profileImage} />
}

export default UserAvatar
